import BaseService from './base.service';

export default class ShareholerRelationshipService extends BaseService {
    constructor(ctx) {
        super(ctx);
    }

    getNewsByCategory = query => {
        console.log(query);
        return this.get('/shareholder-relationship-news/news-by-category', query);
    };

    getNewsById = (news_id, query) => {
        return this.get(`/shareholder-relationship-news/${news_id}`, query);
    };
}
